import { UIDataTypes, UIMessagePart, UITools, isToolUIPart } from 'ai';

type RachelPart = UIMessagePart<UIDataTypes, UITools>;

export const getRachelPartKey = (part: RachelPart, index: number): string =>
  isToolUIPart(part) ? part.toolCallId : `${part.type}-${index}`;
